export const searchFilterDateFormat = 'DD/MM';
export const fullSearchFilterDateFormat = 'DD/MM HH[h]mm';
export const rentalDateFormat = 'D MMM. HH[h]mm';
export const rentalDateMonthFormat = 'D MMMM HH[h]mm';
export const rentalDateLongFormat = 'D MMMM YYYY HH[h]mm';
export const datePickerFormat = 'YYYY/MM/DD H:mm';
export const dateInputFrFormat = 'DD/MM/YYYY';
export const dateInputFormat = 'YYYY/MM/DD';
